import { Modal } from "../Modal";
import React, { useState } from "react";
import { AddEventForm } from "src/components/forms/AddEventForm";
import { InfoMessage } from "src/components/molecules/InfoMessage";
import styles from "src/components/organisms/AddEventModal/styles.module.css";
import { Msg } from "src/i18n/Msg";
import cx from "classnames";

type Props = {
  isOpen: boolean;
  close: () => void;
};

export const AddEventModal: React.FC<Props> = ({ isOpen, close }) => {
  const [isShowDetailModal, setIsShowDetailModal] = useState(false);
  const [editResultName, setEditresultName] = useState("");
  const [showSuccesResult, setShowSuccessResult] = useState(false);

  const handleAddDeatil = () => setIsShowDetailModal((prev) => !prev);

  const handleClickResult = (name: string) => setEditresultName(name);
  return (
    <Modal
      isVisible={isOpen}
      isShowClose={!isShowDetailModal && !editResultName}
      closeModal={() => {
        setIsShowDetailModal(false);
        setEditresultName("");
        setShowSuccessResult(false);
        close();
      }}
      className={cx(styles.eventModal, !!editResultName && styles.eventModalWide)}
      onClick={editResultName ? () => setEditresultName("") : handleAddDeatil}
    >
      {showSuccesResult ? (
        <InfoMessage />
      ) : (
        <>
          <h3>
            {isShowDetailModal ? (
              <Msg id="components.organisms.AddEventModal.detail" />
            ) : editResultName ? (
              <Msg id="components.organisms.AddEventModal.editTitle" />
            ) : (
              <Msg id="components.organisms.AddEventModal.title" />
            )}
          </h3>
          <AddEventForm
            isShowDetailModal={isShowDetailModal || !!editResultName}
            handleAddDeatil={handleAddDeatil}
            close={close}
            handleClickResult={handleClickResult}
            setShowSuccessResult={setShowSuccessResult}
          />
        </>
      )}
    </Modal>
  );
};
